// 모바일 / PC 화면 판별.
// 앱을 처음 열 때 한 번만 정한다. (창 크기를 조절해도 바뀌지 않고, 새로고침하면 다시 판별)
//  - ?view=mobile | ?view=pc  로 강제할 수 있다. (선택은 세션 동안 기억)
//  - 'PC 버전 보기' / '모바일 버전 보기'는 setViewMode()로 같은 값을 저장하고 새로고침한다.
export const MOBILE_MAX_WIDTH = 768
const STORAGE_KEY = 'viewMode'

const readForced = () => {
	try {
		const query = new URLSearchParams(location.search).get('view')
		if (query === 'mobile' || query === 'pc') {
			sessionStorage.setItem(STORAGE_KEY, query)
			return query
		}
		return sessionStorage.getItem(STORAGE_KEY)
	} catch (e) {
		return null
	}
}

const detect = () => {
	const forced = readForced()
	if (forced === 'mobile') return true
	if (forced === 'pc') return false
	return window.innerWidth <= MOBILE_MAX_WIDTH
}

export const isMobile = detect()

export const setViewMode = mode => {
	try {
		sessionStorage.setItem(STORAGE_KEY, mode)
	} catch (e) {}
	// 쿼리의 view 값이 남아 있으면 다시 덮어쓰므로 지우고 새로고침한다.
	const url = new URL(location.href)
	url.searchParams.delete('view')
	location.href = url.toString()
}

if (isMobile) document.documentElement.classList.add('is-mobile')
